import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tooltip,
  DialogActions,
  Button,
} from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

interface JsonDetailDialogProps {
  open: boolean
  title?: string
  rawContent?: string | null
  onClose: () => void
}

const formatContent = (content?: string | null): string => {
  if (!content) return ''
  try {
    const parsed = JSON.parse(content)
    return JSON.stringify(parsed, null, 2)
  } catch {
    return content
  }
}

const JsonDetailDialog: React.FC<JsonDetailDialogProps> = ({
  open,
  title = 'Detalhes',
  rawContent,
  onClose,
}) => {
  const formatted = React.useMemo(() => formatContent(rawContent), [rawContent])

  const handleCopy = async () => {
    if (!formatted) return
    try {
      await navigator.clipboard.writeText(formatted)
    } catch (err) {
      // Erro ao copiar é silencioso - funcionalidade não crítica
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 2,
          gap: 1,
        }}
      >
        {title}
        <Tooltip title="Copiar conteúdo">
          <span>
            <IconButton onClick={handleCopy} disabled={!formatted}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          fontFamily: 'JetBrains Mono, monospace',
          fontSize: '0.9rem',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          backgroundColor: 'background.paper',
        }}
      >
        {formatted || 'Sem detalhes disponíveis'}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} size="small">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default JsonDetailDialog

